export const LeadStageTypeId = {
  1: 'New',
  3: 'Want Intro',
  4: 'Hot Intro',
  5: 'Appraised',
  6: 'Listed',
  7: 'Sold',
  8: 'Review',
  13: 'Under Offer',
};

export const LeadStageType = {
  New: 1,
  Want_Intro: 3,
  Hot_Intro: 4,
  Appraised: 5,
  Listed: 6,
  Sold: 7,
  Reviewed: 8,
  Pre_Sale: 13,
};
